import { ReactNode, RefObject } from 'react';
import { InterpolationValue } from 'styled-components';
import { LinkTrackingData } from '../../AnalyticsContext/LinkTracking';
import { renderLinkTrackingAttributes } from '../../AnalyticsContext/renderLinkTrackingAttributes';
import { ThemeColours } from '../../styles/ThemeColours';
import { AccordionWrapper, AccordionItem } from './Accordion.styles';
import { Question } from './Question';
import { useShowingIndex } from './useShowingIndex';

export type ContentType = {
  question: string;
  answer: ReactNode;
  ref?: RefObject<HTMLDivElement> | null;
};

export interface Props {
  questions: ContentType[];
  trackingData?: LinkTrackingData;
  bgColor?: InterpolationValue;
}

export const Accordion = ({ questions, trackingData, bgColor = ThemeColours.white }: Props) => {
  const { showingIndex, setShowingIndex } = useShowingIndex();

  return (
    <AccordionWrapper bgColor={bgColor}>
      {questions.map(({ question, answer, ref }, index) => (
        <AccordionItem key={index} ref={ref}>
          <Question
            answer={answer}
            index={index}
            isOpen={index === showingIndex}
            onClick={() => setShowingIndex(index !== showingIndex ? index : null)}
            question={question}
            setShowingIndex={setShowingIndex}
            {...renderLinkTrackingAttributes({ accordionTitle: question, ...trackingData })}
          />
        </AccordionItem>
      ))}
    </AccordionWrapper>
  );
};
